import { render, staticRenderFns } from "./MemberDetailOrders.vue?vue&type=template&id=809dcec6"
import script from "./MemberDetailOrders.vue?vue&type=script&lang=js"
export * from "./MemberDetailOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports